import React, { useState } from "react";
import axios from "axios";
import { CalendarClock, AlertTriangle } from "lucide-react";
import { isDeadlineExpired } from "../../utils/deadline";
import { ModalPortal } from "../ui/ModalPortal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// П.3 TZ-6: бейдж «срок истёк» (карточка, чат, админка)
export const ExpiredBadge = ({ task, testId }) => {
  if (!isDeadlineExpired(task)) return null;
  return (
    <span data-testid={testId || `deadline-expired-badge-${task.id}`} className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded"
      style={{ background: "#FEF2F2", color: "#B91C1C", border: "1px solid #FECACA" }}>
      <AlertTriangle size={12} />{task.expiry_frozen ? "Срок истёк · заморожено" : "Срок истёк"}
    </span>
  );
};

// П.3 TZ-6: продление срока решением заказчика (7/14/30 дней или дата), доступно и после истечения
export const ExtendDeadlineButton = ({ task, showToast, onDone }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (payload) => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/tasks/${task.id}/extend-deadline`, payload);
      showToast && showToast(r.data.message || "Срок продлён", "success");
      setOpen(false);
      onDone && onDone();
    } catch (e) {
      showToast && showToast(e.response?.data?.detail || "Не удалось продлить срок", "error");
    } finally { setBusy(false); }
  };

  return (
    <>
      <button type="button" data-testid={`extend-deadline-btn-${task.id}`} onClick={() => setOpen(true)} className="reversia-btn reversia-btn-quiet reversia-btn-md">
        <CalendarClock size={14} className="inline mr-1.5" />Продлить срок
      </button>
      {open && (
        <ModalPortal>
        <div className="fixed inset-0 flex items-center justify-center p-4" style={{ background: "rgba(15,23,42,0.45)", zIndex: 10002 }} onClick={() => !busy && setOpen(false)} data-testid={`extend-deadline-overlay-${task.id}`}>
          <div className="bg-white rounded-2xl p-5 w-full max-w-sm space-y-4" onClick={(e) => e.stopPropagation()} data-testid={`extend-deadline-modal-${task.id}`}>
            <h4 className="text-base font-semibold" style={{ fontFamily: "Manrope,sans-serif", color: "var(--rv-text-primary)" }}>Продлить срок задания</h4>
            <p className="text-xs" style={{ color: "var(--rv-text-secondary)" }}>Исполнитель получит уведомление о новом сроке. Изменение сохранится в журнале задания.</p>
            <div className="grid grid-cols-3 gap-2">
              {[7, 14, 30].map((d) => (
                <button key={d} type="button" disabled={busy} onClick={() => submit({ days: d })} data-testid={`extend-deadline-${d}-btn`}
                  className="reversia-btn reversia-btn-teal reversia-btn-md justify-center">+{d} дн.</button>
              ))}
            </div>
            <div className="flex items-end gap-2">
              <label className="flex-1 text-xs" style={{ color: "var(--rv-text-secondary)" }}>Или до даты
                <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="extend-deadline-date-input"
                  className="w-full mt-1 px-3 py-2 rounded-lg text-sm" style={{ border: "1px solid var(--rv-border)" }} />
              </label>
              <button type="button" disabled={busy || !date} onClick={() => submit({ new_deadline: date })} data-testid="extend-deadline-date-submit"
                className="reversia-btn reversia-btn-quiet reversia-btn-md">Сохранить</button>
            </div>
            <button type="button" onClick={() => setOpen(false)} disabled={busy} data-testid="extend-deadline-cancel-btn" className="text-xs underline" style={{ color: "var(--rv-text-muted)" }}>Закрыть</button>
          </div>
        </div>
        </ModalPortal>
      )}
    </>
  );
};
